import { DATA_TABLE_ROW_DRAG_COLUMN_ID } from '../../constants.js';
import type { ColumnDef } from '../../hooks/useTable/types.js';

/**
 * Helper function to identify the row drag column.
 * @internal
 */
export function isRowDragColumnDef<TData>(column: ColumnDef<TData>): boolean {
  return column.id === DATA_TABLE_ROW_DRAG_COLUMN_ID;
}
